import { useState, useEffect } from "react";
import {
	Button,
	Modal,
	Form,
	Input,
	Select,
	Typography,
	message,
	Image,
} from "antd";
import { sellBoostFetch } from "../../utlifyFunction";
import PrimaryButton from "../../components/Buttons/PrimaryButton";
import CustomTable from "../../components/Table/CustomTable";
import CreateBulkOrderConfigurations from "../../components/Modals/CreateBulkOrderConfiguratoions";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const { Paragraph } = Typography;

const { Title } = Typography;
const { TextArea } = Input;

const CreateBulkOrder = () => {
    const navigate=useNavigate()
	const [selectedProducts, setSelectedProducts] = useState([]);
	const [products, setProducts] = useState(null);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [loading, setLoading] = useState(false);
	const [form] = Form.useForm();

	const columns = [
		{
			title: "Title",
			dataIndex: "title",
			key: "title",
			width: "100px",
			render: (_, record) => (
				<Image
					src={record?.images?.edges?.[0]?.node?.originalSrc || ""}
					alt={record?.title || "Product Image"}
					style={{ height: 50, objectFit: "cover" }}
					fallback="https://via.placeholder.com/200"
				/>
			),
		},
		{
			title: "Title",
			dataIndex: "title",
			key: "title",
			width: "250px",
			render: (text) => (
				<Title level={5} style={{ minWidth: "150px", margin: "0" }}>
					{text}
				</Title>
			),
		},
		{
			title: "Description",
			dataIndex: "description",
			key: "description",
			render: (text) => (
				<Paragraph ellipsis={{ rows: 2 }}>
					{text || "No description available."}
				</Paragraph>
			),
		},
	];

	const fetchProducts = async () => {
		const data = await sellBoostFetch("POST", "/shopify/fetchProducts");
		setProducts(data?.products || []);
	};

	useEffect(() => {
		fetchProducts();
	}, []);

	const rowSelection = {
		onChange: (_, selectedRows) => {
			setSelectedProducts(selectedRows);
		},
	};

	const handleCreateOrder = () => {
		if (selectedProducts.length === 0) {
			message.warning("Please select at least one product");
			return;
		}
		setIsModalVisible(true);
	};

	const handleSubmitOrder = async (values) => {
		setLoading(true);
		try {
			const payload = {
				productIds: selectedProducts.map((p) => p.id),
                configurations: {...values}
			};

			const data=await sellBoostFetch("POST", "/AI/create-bulk-order", payload);
            if(data?.status===200){
                toast.success("Bulk order created successfully");
                setIsModalVisible(false);
                navigate('/bulk-AI-generation')
            }
			setSelectedProducts([]);
		} catch (error) {
			message.error("Failed to create bulk order");
		} finally {
			setLoading(false);
		}
	};

	return (
		<div style={{ padding: "24px" }}>
			<Title level={4} style={{ marginBottom: "24px" }}>
				Create Bulk Order
			</Title>

			<CustomTable
				rowSelection={{
					type: "checkbox",
					...rowSelection,
				}}
				columns={columns}
				data={products} // Connect to your product data source
				rowKey="id"
			/>

			<div style={{ marginTop: "24px", textAlign: "right" }}>
				<PrimaryButton
					type="primary"
					onClick={handleCreateOrder}
					disabled={selectedProducts.length === 0}
				>
					Create Order ({selectedProducts.length} products)
				</PrimaryButton>
			</div>

			<CreateBulkOrderConfigurations
				isModalVisible={isModalVisible}
				setIsModalVisible={setIsModalVisible}
                submitOrder={handleSubmitOrder}
			/>
		</div>
	);
};

export default CreateBulkOrder;
